import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.helpers.branch-switch.';
  public static readonly branchSwitchConfirmation = `${Id.prefix}branchSwitchConfirmation`;
  public static readonly branchSwitchNotPartOfBranch = `${Id.prefix}branchSwitchNotPartOfBranch`;
  public static readonly branchDeactivatedAutoSwitch = `${Id.prefix}branchDeactivatedAutoSwitch`;
}

export class LangBranchSwitch {
  private constructor() {}
  public static branchSwitchConfirmation(params: {
    resourceName: string;
    branchName: string;
    defaultBranchName: string;
  }): string {
    return interpolate(Id.branchSwitchConfirmation, params);
  }
  public static branchSwitchNotPartOfBranch(params: { resourceName: string }): string {
    return interpolate(Id.branchSwitchNotPartOfBranch, params);
  }
  public static branchDeactivatedAutoSwitch(): string {
    return interpolate(Id.branchDeactivatedAutoSwitch);
  }
}

export class BranchSwitchModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.branchSwitchConfirmation,
      "The {{resourceName}} you are trying to open belongs to {{glossary 'branch'}} **'{{branchName}}'**\n\n**Do you want to switch {{glossary 'branch'}} to view the {{resourceName}}?**\n\nPress cancel to stay on {{glossary 'branch'}} **'{{defaultBranchName}}'**",
      'Confirmation message when switching branches to view a resource, uses markdown for formatting and includes branch and resource names'
    );
    register.add(
      Id.branchSwitchNotPartOfBranch,
      'This {{resourceName}} is not part of your available branches',
      'Message shown when a resource belongs to a hidden branch or the user has no available branches'
    );
    register.add(
      Id.branchDeactivatedAutoSwitch,
      "The {{glossary 'branch'}} you were working on has been deactivated by an administrator. We've switched you to the next available {{glossary 'branch'}}. You can manually switch to your preferred {{glossary 'branch'}} anytime.",
      'Informational message when the active branch is auto-switched after an administrator deactivates it'
    );
  }
}
